import Avatar from "@mui/material/Avatar";
import StoreIcon from '@mui/icons-material/Store';

export const businessImageStyles = {
  width: 53,
  height: 53,
  borderRadius: "5px"
}

export const iconStyles = {
  width: "40px",
  height: "40px"
}

export default function BusinessImage({businessImage="", customStyles}){
  return (
    <Avatar src={businessImage} sx={customStyles || businessImageStyles}>
      <StoreIcon sx={iconStyles}/>
    </Avatar>
  );
}